import Table from "../Table";
/**
 * 通用页面组件
 */
export function Page({ table = null, ...props }) {
    return <Table table={table} {...props} />;
}
